// find all the submenu items
const subMenus = document.querySelectorAll('.header-navbar-menu.has-submenu');
// find all header nav links
const headerMenus = document.querySelectorAll('.header-navbar-menu-links');

// toggle the submenu
function toggleSubMenu(event) {
	event.stopPropagation();
	const menu = event.currentTarget;
	const isActive = menu.classList.contains('active');
	subMenus.forEach((item) => {
		item.classList.remove('active');
		// set aria-expanded to false for accessibility
		menu.querySelector('button').setAttribute('aria-expanded', 'false');
	});
	menu.classList.toggle('active', !isActive);
	// set aria-expanded for accessibility
	menu.querySelector('button').setAttribute('aria-expanded', !isActive);
}

// close the submenu
function closeSubMenus() {
	subMenus.forEach((item) => {
		item.classList.remove('active');
		item.querySelector('button').setAttribute('aria-expanded', 'false');
	});
}

subMenus.forEach((menu) => {
	// toggle submenu on menu click
	menu.addEventListener('click', toggleSubMenu);

	// get the sub menu class
	const subMenu = menu.querySelector('.header-navbar-sub-menu');

	// set the grid template based on number of submenu items
	if (subMenu) {
		const menuItemNumber = subMenu.getAttribute('data-menu-items');
		const countRows = Math.ceil(menuItemNumber / 2);
		subMenu.style.gridTemplateRows = `repeat(${countRows},auto)`;
	}
});

// close the submenu when navigating to other header menu items
headerMenus.forEach((menu) => {
	menu.addEventListener('focus', () => {
		closeSubMenus();
	});
});

// close the submenu on click outside and on esc key
document.addEventListener('click', closeSubMenus);
document.addEventListener('keydown', (event) => {
	if (event.key === 'Escape') {
		closeSubMenus();
	}
});
